import type { CSSProperties } from 'react';

import classes from './LoadingBar.module.css';

type Props = {
    title?: string;
    testId?: string;
    style?: CSSProperties;
    /**
     * Add a slightly darker background to the loader to make it stand out more against white/light backgrounds.
     *
     * @default false
     */
    addBackground?: boolean;
};

export const LoadingBar = (props: Props) => (
    <>
        {props.title && <div className={classes.title}>{props.title}</div>}
        <div
            className={props.addBackground ? `${classes.loadingBar} ${classes.addBackground}` : classes.loadingBar}
            data-testid={props.testId}
            style={props.style}
        >
            <div className={classes.innerContainer}>
                <div className={`${classes.bar} ${classes.nonBlocking}`} />
            </div>
        </div>
    </>
);

export default LoadingBar;
